module.exports = __webpack_public_path__ + "static/spinner-limit-do-c79496e989f6e121d46cc2c0649fe7fc.png";